import React, {useEffect, useState, Fragment} from "react";
import { isAuthenticated } from "./helper";
import {useParams} from "react-router-dom";
import { Link } from "react-router-dom";
import AppTheme from "../colors";

const UserProfile = () => {
    const [userProfile, setUserProfile] = useState(null)
    const theme = JSON.parse(localStorage.getItem("theme"));
    const currentTheme =  AppTheme["light"]
    const {user, token} = isAuthenticated()
    const {id} = useParams()
    const [showFollow, setShowFollow] = useState(!user.following.includes(id))
    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND}/finduser/${id}/${user._id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then(res => res.json() )
        .then(res => {
            console.log(res)
            setUserProfile(res)
        })
        .catch(err => console.log(err));

    }, [])
    const followUser = () => {
        fetch(`${process.env.REACT_APP_BACKEND}/follow/${user._id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                followId: id
            })
        })
        .then(res => res.json())
        .then(data => {
            console.log("DATA", data);
            var existing = JSON.parse(localStorage.getItem("jwt"));
            existing.user.followers = data.followers;
            existing.user.following = data.following;
            localStorage.setItem("jwt", JSON.stringify(existing));
            
            setUserProfile((previous) => {
                return{
                    ...previous,
                    user: {
                        ...previous.user,
                        followers: [...previous.user.followers, data._id]
                    }
                }
            })
            setShowFollow(false)
        })
    }
    const unfollowUser = () => {
        fetch(`${process.env.REACT_APP_BACKEND}/unfollow/${user._id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                unfollowId: id
            })
        })
        .then(res => res.json())
        .then(data => {
            console.log("DATA",data);
            var existing = JSON.parse(localStorage.getItem("jwt"));
            existing.user.followers = data.followers;
            existing.user.following = data.following;
            localStorage.setItem("jwt", JSON.stringify(existing));
            setUserProfile((previous) => {
                const newFollower = previous.user.followers.filter(item => item!= data._id)
                return{
                    ...previous,
                    user: {
                        ...previous.user,
                        followers: newFollower
                    }
                }
            })
            setShowFollow(true)
        })
    }
    return (
        <>
        {userProfile ? (
            <div className="row" style={{ color: `${currentTheme.textColor}` }}>
            <div className="col s12">
            <div style={{maxWidth:"550px",margin:"10px auto"}}>
            <div style={{
                display:"flex",
                justifyContent:"space-around",
                borderBottom: "1px solid grey"
            }}>
                <div><img style={{width: "120px", height: "120px", borderRadius:"80px"}} src={userProfile.user.pic} /></div>
                <div>
                    <h4 style={{textAlign: "center"}}>{userProfile.user.name}</h4>
                    <div style={{display:"flex",justifyContent:"space-around",width:"100%"}}>
                       <h6 style={{ marginLeft: "5%", textAlign:"center"}}>{userProfile.posts.length} Posts</h6>
                       <h6 style={{ marginLeft: "5%", textAlign:"center"}}>{userProfile.user.followers.length} Followers</h6>
                       <h6 style={{ marginLeft: "5%", textAlign:"center"}}>{userProfile.user.following.length} Following</h6>
                   </div>
                   {showFollow ? (
                    <button style={{margin: "10px"}} className="btn waves-effect waves-light #64b5f6 blue darken-1" onClick={followUser}>
                        Follow
                    </button>
                   ) : (
                    <button style={{margin: "10px"}} className="btn waves-effect waves-light #64b5f6 blue darken-1" onClick={unfollowUser}>
                        Unfollow
                    </button>
                   )}
                   
                   
                </div>
            </div>
            {userProfile.posts.length === 0 ? (
                <div className="row">
                    <div className="col offset-s3 s6 center-align">
                        <h6>No post available</h6>
                    </div>
                </div>
                
            ) : (
                <div className="row">
            {
                userProfile.posts.map(item => {
                    return(
                        <div className="col s6">
                            <Link to={`/post/${item._id}`}><img key={item._id}  style={{width: "100%", height: "100%"}} className="item" src={item.photo} alt={item.title}/></Link>
                        </div>
                    )
                })
            }
                
            </div>
            ) }
            
        </div>
        </div>
        </div>
        ) : (
            <div className="preloader-background">
            <div class="preloader-wrapper big active">
                <div class="spinner-layer spinner-blue-only">
                <div class="circle-clipper left">
                    <div class="circle"></div>
                </div><div class="gap-patch">
                    <div class="circle"></div>
                </div><div class="circle-clipper right">
                    <div class="circle"></div>  
                </div>
                </div>
            </div>
            </div>
        ) }
        </>
        
    )
}

export default UserProfile;